import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import defaultImage from "../../assets/images/icons/dome-logo.svg"; 
import { AppConfig } from "../../api/config/config"; 
import Modal from "../Common/Modal";
import FilePreview from "./FilePreview";

export interface GeneralImageProps {
  src?: string | null;
  alt?: string;
  className?: string;
  isLoad?: any;
  imageToLoad?: string;
  width?: string;
  height?: string;
  onClick?: React.MouseEventHandler<HTMLImageElement>;
  withPreview?: boolean; 
}

const GeneralImage: React.FC<GeneralImageProps> = ({
  src,
  alt,
  className,
  imageToLoad,
  width,
  onClick,
  height,
  withPreview, 
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState<boolean>(false);
  return (
    <div>
      <LazyLoadImage
        src={
          src
            ? AppConfig.SERVER_URL + src
            : imageToLoad
              ? imageToLoad
              : defaultImage
        }
        alt={alt}
        effect="blur"
        placeholderSrc={imageToLoad ? imageToLoad : defaultImage}
        className={`w-full shrink-0 select-none object-cover ${withPreview && "cursor-pointer"} ${className}`}
        width={width}
        draggable={false}
        height={height}
        onClick={(event) => {
          onClick && onClick(event);
          withPreview && setIsPreviewOpen(true);
        }}
      />

      {isPreviewOpen && withPreview && (
        <Modal 
          isOpen={isPreviewOpen}
          onClose={() => setIsPreviewOpen(false)}
        >
          <FilePreview type="IMAGE" url={AppConfig.SERVER_URL + src} />
        </Modal>
      )}
    </div>
  ); 
};

export default GeneralImage;
